/**
 * Collision-resistant ids for newly added rows.
 *
 * The previous implementation used a per-load counter, which collided with
 * persisted rows as soon as anything was saved and reloaded. UUIDs are stable
 * across sessions and safe to use as a primary key in the API later.
 */
export function newId(prefix: string): string {
  const uuid =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return `${prefix}-${uuid.slice(0, 8)}`;
}
